const mainRoute = {
  ERROR: '/error',
  DASHBOARD: '/dashboard',
};

const dashboardRoute = {
  HOME: `${mainRoute.DASHBOARD}/home`,
  USER_CONTROL: `${mainRoute.DASHBOARD}/user-control`,
  AUDIT: `${mainRoute.DASHBOARD}/audit`,
};

export default {
  ...mainRoute,
  ...dashboardRoute,
};
